
const DiscountMethod = {
    PERCENTAGE: "PERCENTAGE",
    DIFFERENCE: "DIFFERENCE",
    ACQUISITION_PRICE: "ACQUISITION_PRICE"
};

export default DiscountMethod;